<script setup lang="ts">
import { RouterLink } from 'vue-router';
import IssueRow from './IssueRow.vue';
import type { IssueListItemDto } from '@/stores/issues';

interface Props {
  issues: IssueListItemDto[];
}
defineProps<Props>();
</script>

<template>
  <div class="overflow-x-auto rounded-lg border border-border">
    <table class="w-full text-sm" data-testid="issue-table">
      <thead class="bg-canvas-soft border-b border-border">
        <tr>
          <th class="py-2 pl-4 pr-2 text-left text-caption font-medium text-muted">Severity</th>
          <th class="py-2 px-2 text-left text-caption font-medium text-muted">Issue</th>
          <th class="py-2 px-2 text-left text-caption font-medium text-muted hidden md:table-cell">Source</th>
          <th class="py-2 px-2 text-left text-caption font-medium text-muted hidden lg:table-cell">Assignee</th>
          <th class="py-2 px-2 text-left text-caption font-medium text-muted">Status</th>
          <th class="py-2 px-2 text-left text-caption font-medium text-muted hidden xl:table-cell">AI Confidence</th>
          <th class="py-2 pl-2 pr-4 text-right text-caption font-medium text-muted hidden sm:table-cell">Updated</th>
        </tr>
      </thead>
      <tbody>
        <RouterLink
          v-for="issue in issues"
          :key="issue.id"
          v-slot="{ navigate }"
          :to="`/issues/${issue.id}`"
          custom
        >
          <IssueRow :issue="issue" @click="navigate" />
        </RouterLink>
        <tr v-if="issues.length === 0">
          <td colspan="7" class="py-12 text-center text-body text-muted">
            No issues match the current filters.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
